export const defaultArMainnetConfig = {
  host: 'arweave.net',
  protocol: 'https',
  timeout: 100000,
}

export const defaultArTestnetConfig = {
  host: 'localhost',
  port: '1984',
  protocol: 'http',
  timeout: 100000,
}

export const AR_DECIMAL = 12
